import { withLayout } from 'pages/Layout'
import DocumentsPage from './DocumentsPage'

export default withLayout('documents', DocumentsPage)
